import styled from "@emotion/styled";
import React from "react";

interface ModalContentProps {
  mainMessage: string;
  subMessage?: string;
  errorMessage?: string;
}

const Content = styled.div(({ theme }) => ({
  lineHeight: "2.4rem",
  // padding: "4.4rem 0",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
}));

const ErrorMessage = styled.p(({ theme }) => ({
  color: theme.color.orange,
  fontSize: "1.2rem",
  fontBold: theme.fontWeight.medium,
  margin: "3rem 0",
}));

export const ModalContent: React.FC<ModalContentProps> = ({
  mainMessage,
  subMessage,
  errorMessage,
}) => {
  return (
    <Content>
      <p>{mainMessage}</p>
      <p>{subMessage ? subMessage : ""}</p>

      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Content>
  );
};
